import { Module } from "vuex";
import { RootState } from "..";
import { SportEvent } from "../../models/sport-events.model";
import { Statistics } from "./../../models/statistics.model";
import { actions } from "./home.actions";
import { mutations } from "./home.mutations";

export interface HomeState {
  statistics?: Statistics;
  mainSportEvents: SportEvent[];
  sportEventsList: SportEvent[];
}

const state: HomeState = {
  statistics: undefined,
  mainSportEvents: [],
  sportEventsList: []
};

export const namespaceHome = "home";

export const homeModule: Module<HomeState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};

export * from "./home.actions";
export * from "./home.mutations";
